import { DEFAULT_FILTERS_CONFIGURATION } from 'shared-constants/src/filters';

export const filterBtnClass = 'filter-btn';

export const smallBtnCls = `${filterBtnClass} smallbutton`;

export const filterBtnLargeClass = `${filterBtnClass}__multi-l`;

export const filterBtnLargeAllClass = `${filterBtnLargeClass}-all`;

export const QUERYSTRING_FILTERS = [
  'zones',
  'surrounding',
  'numRooms',
  'numBaths',
  'numParkingSpaces',
  'garden',
  'balcony',
  'terrace',
  'level',
  'lift',
  'heatingType',
  'availability',
  'buildingCondition',
  'energyClass',
  'sellerType',
  'photo',
  'has_virtual_tour',
];

export const FILTERS_TO_EXCLUDE_FROM_DISPLAY_COUNT = [
  'channel',
  'category',
  'surrounding',
  'priceType',
  'mortgage',
  'oldcategory',
  'propertyTypes',
];

export const RANGE_FILTERS = [
  'mq',
  'buildingYear',
  'price',
  'mqprice',
  'payment',
];

export const EURO_FILTERS = [
  'price',
  'mqprice',
  'payment',
];

export const aboveFilterSections = {
  category: ['category', 'propertyTypes'],
};

export const filterBoxesConfiguration = {
  lone: {
    has_virtual_tour: 'has_virtual_tour',
  },
  top: {
    price: ['priceType', 'price', 'exclude_private_negotiation', 'only_private_negotiation'],
    mq: 'mq',
    rooms: 'numRooms',
    baths: 'numBaths',
    level: 'level',
    lift: 'lift',
    numParkingSpaces: 'numParkingSpaces',
    balcony: ['balcony', 'terrace'],
    garden: 'garden',
    buildingCondition: 'buildingCondition',
    energyClass: 'energyClass',
    heatingType: 'heatingType',
    air_conditioned: 'air_conditioned',
    furniture: 'furniture',
    has_swimming_pool: 'has_swimming_pool',
    has_reception: 'has_reception',
    buildingYear: 'buildingYear',
  },
  bottom: {
    availability: 'availability',
    exclude_auction: 'exclude_auction',
    exclude_under_construction: 'exclude_under_construction',
    sellerType: 'sellerType',
    publication_date: 'publication_date',
    photo: 'photo',
  },
};

export const filterSections = {
  price: ['priceType', 'price', 'exclude_private_negotiation', 'only_private_negotiation'],
  mq: 'mq',
  rooms: 'numRooms',
  level: 'level',
  lift: 'lift',
  baths: 'numBaths',
  balcony: ['balcony', 'terrace'],
  garden: 'garden',
  has_swimming_pool: 'has_swimming_pool',
  numParkingSpaces: 'numParkingSpaces',
  buildingCondition: 'buildingCondition',
  heatingType: 'heatingType',
  air_conditioned: 'air_conditioned',
  furniture: 'furniture',
  has_reception: 'has_reception',
  energyClass: 'energyClass',
  buildingYear: 'buildingYear',
  availability: 'availability',
  sellerType: 'sellerType',
  exclude_under_construction: 'exclude_under_construction',
  exclude_auction: 'exclude_auction',
  // Solo annunci con foto ('photo')
  has_virtual_tour: 'has_virtual_tour',
  photo: 'photo',
  publication_date: 'publication_date',
};

/**
 * Filters names showd inside home pop up after clicking in "Aggiungi filtri"
 */
export const filterSectionNames = {
  category: 'Cerco',
  channel: 'in',
  price: 'Prezzo',
  mq: 'Metri quadri',
  rooms: 'Locali',
  baths: 'Bagni',
  numParkingSpaces: 'Box / Posti Auto',
  level: 'Piano',
  lift: 'Ascensore',
  heatingType: 'Riscaldamento',
  garden: 'Giardino',
  balcony: 'Balcone / Terrazzo',
  energyClass: 'Classe energetica',
  buildingCondition: 'Condizione immobile',
  buildingYear: 'Anno di costruzione',
  availability: 'Stato al rogito',
  sellerType: 'Annunci da',
  furniture: 'Arredamento',
  air_conditioned: 'Aria condizionata',
  is_lux: 'Immobili di prestigio',
  publication_date: 'Data di pubblicazione',
  exclude_under_construction: 'Immobili in costruzione',
  exclude_private_negotiation: 'Trattative riservate',
  only_private_negotiation: 'Trattative riservate',
  exclude_auction: 'Aste',
  has_swimming_pool: 'Piscina',
  has_reception: 'Portineria',
  has_virtual_tour: 'Visita guidata da casa',
};

export const filterSectionNamesForSeoLinks = {
  price: 'Prezzo',
  mq: 'Metri quadri',
  rooms: 'Locali',
  baths: 'Bagni',
  numParkingSpaces: 'Box / Posti Auto',
  level: 'Piano',
  lift: 'Ascensore',
  heatingType: 'Riscaldamento',
  garden: 'Giardino',
  balcony: 'Balcone',
  terrace: 'Terrazzo',
  energyClass: 'Classe energetica',
  buildingCondition: 'Condizione immobile',
  buildingYear: 'Anno di costruzione',
  availability: 'Stato al rogito',
  sellerType: 'Annunci da',
  furniture: 'Arredamento',
  air_conditioned: 'Aria condizionata',
  is_lux: 'Immobili di prestigio',
  publication_date: 'Data di pubblicazione',
  exclude_under_construction: 'Case pronte e in costruzione',
  exclude_auction: 'Escludi aste',
  has_swimming_pool: 'Case con o senza piscina',
  has_reception: 'Case con o senza portineria',
  has_virtual_tour: 'Visita live da casa',
};

export const valuePriceSell = [
  ['0', '-'], ['10000'], ['20000'], ['30000'], ['40000'], ['50000'], ['60000'], ['70000'], ['80000'], ['90000'], ['100000'],
  ['110000'], ['120000'], ['130000'], ['140000'], ['150000'], ['175000'], ['200000'], ['225000'], ['250000'], ['275000'],
  ['300000'], ['350000'], ['400000'], ['450000'], ['500000'], ['550000'], ['600000'], ['650000'], ['700000'], ['750000'],
  ['800000'], ['850000'], ['900000'], ['950000'], ['1000000'], ['1250000'], ['1500000'], ['1750000'], ['2000000'],
  ['2500000'], ['3000000'], ['4000000'], ['5000000'], ['10000000'],
].map(([value, display]) => ({
  display: display || value,
  value,
  count: 0,
}));

export const valuePriceRent = [
  ['0', '-'], ['50'], ['100'], ['150'], ['200'], ['250'], ['300'], ['350'], ['400'], ['450'], ['500'], ['550'],
  ['600'], ['650'], ['700'], ['750'], ['800'], ['850'], ['900'], ['950'], ['1000'], ['1100'], ['1200'], ['1300'],
  ['1400'], ['1500'], ['1600'], ['1700'], ['1800'], ['1900'], ['2000'], ['2500'], ['3000'], ['3500'], ['4000'],
  ['4500'], ['5000'], ['5500'], ['6000'], ['6500'], ['7000'], ['7500'], ['8000'], ['8500'], ['9000'], ['9500'], ['10000'],
].map(([value, display]) => ({
  display: display || value,
  value,
  count: 0,
}));

export const valueMqSell = [
  ['0', '-'], ['1000'], ['1100'], ['1200'], ['1300'], ['1400'], ['1500'], ['1600'], ['1700'], ['1800'], ['1900'],
  ['2000'], ['2100'], ['2200'], ['2300'], ['2400'], ['2500'], ['2600'], ['2700'], ['2800'], ['2900'], ['3000'],
  ['3100'], ['3200'], ['3300'], ['3400'], ['3500'], ['3600'], ['3700'], ['3800'], ['3900'], ['4000'],
].map(([value, display]) => ({
  display: display || value,
  value,
  count: 0,
}));

export const valueMqRent = [
  ['0', '-'], ['1'], ['2'], ['3'], ['4'], ['5'], ['6'], ['7'], ['8'], ['9'], ['10'], ['11'], ['12'], ['13'],
  ['14'], ['15'], ['16'], ['17'], ['18'], ['19'], ['20'], ['25'], ['30'],
].map(([value, display]) => ({
  display: display || value,
  value,
  count: 0,
}));

export const filterOldCategory = {
  component: 'Buttons',
  mobileComponent: 'Buttons',
  multiple: false,
  currentValue: null,
  defaultValue: 'residenziale',
  values: [
    {
      display: 'residenziale',
      value: 'residenziale',
      count: 0,
    },
    {
      display: 'commerciale',
      value: 'commerciale',
      count: 0,
    },
    {
      display: 'vacanze',
      value: 'vacanze',
      count: 0,
    },
  ],

  excludeValues: {},
  dependsOn: null,
  updates: null,

  label: 'Categoria',
  labelOnly: 'Categoria',
  humanDefaultValue: 'Residenziale',
  humanValueMeasureUnit: '',
  containerCssClass: null,
  itemCssClass: `${filterBtnClass} button`,
  disabledByCount: false,
  isNew: false,
  resetButton: true,
};

export const propTypeGroup = {
  component: 'Select',
  mobileComponent: 'Buttons',
  multiple: false,
  currentValue: null,
  defaultValue: 'case',
  defaultDisplay: 'Casa',
  values: [
    ['Casa', 'case'],
    ['Nuova Costruzione', 'nuove-costruzioni'],
    ['Immobile o Attività Commerciale', 'commerciale'],
    ['Terreno', 'terreni'],
    ['Garage e Posto auto', 'garage-posti-auto'],
    ['Stanza singola', 'stanze'],
    ['Cantina o Solaio', 'cantine-solai'],
  ].map(([display, value]) => ({
    display,
    value,
    count: 0,
  })),
  excludeValues: {
    vacanze: {
      type: 'channel',
      value: 'vendita',
    },
  },
  dependsOn: null,
  updates: 'propertyTypes',

  label: 'Categoria',
  labelOnly: 'Categoria',
  humanDefaultValue: 'Casa',
  humanValueMeasureUnit: '',
  containerCssClass: null,
  itemCssClass: 'button nohighlight',
  disabledByCount: false,
  isNew: false,
  resetButton: false,
};

// Values to handle 'affitti-brevi'
export const propTypeGroupValuesRent = [
  {
    display: 'Casa',
    value: 'case-vacanza',
    count: 0,
  },
  ...propTypeGroup.values.slice(1),
];

export const propTypeGroupRent = {
  ...propTypeGroup,
  values: propTypeGroupValuesRent,
};

const COMPUTE_DEFAULT_FILTERS_VALUES = () => {
  const defaultFiltersValues = {};
  Object.keys(DEFAULT_FILTERS_CONFIGURATION).forEach(
    (filter) => {
      if ('defaultMinValue' in DEFAULT_FILTERS_CONFIGURATION[filter]) {
        defaultFiltersValues[`${filter}Min`] = DEFAULT_FILTERS_CONFIGURATION[filter].defaultMinValue;
        defaultFiltersValues[`${filter}Max`] = DEFAULT_FILTERS_CONFIGURATION[filter].defaultMaxValue;
      } else {
        defaultFiltersValues[filter] = DEFAULT_FILTERS_CONFIGURATION[filter].defaultValue;
      }
    },
  );
  defaultFiltersValues.sortType = 'default';
  return defaultFiltersValues;
};

export const DEFAULT_FILTERS_VALUES = COMPUTE_DEFAULT_FILTERS_VALUES();

export const licenseTypeGroupPlurals = (ltgs) => {
  const ret = [];
  const arr = !Array.isArray(ltgs) ? ltgs.split(',') : ltgs;
  arr.forEach((ltg) => {
    const check = ltg.replace(/à/g, 'a').replace(/-/g, ' ').toLowerCase();
    const match = DEFAULT_FILTERS_CONFIGURATION.license_type_groups.values.filter((val) => val.display.replace(/à/g, 'a').toLowerCase() === check || val.slug.replace(/-/g, ' ').toLowerCase() === check)[0];
    if (match) {
      ret.push(match.plural);
    }
  });
  return ret.length ? ret : null;
};
